module.exports = __webpack_public_path__ + "media/images/flags/64/Venezuela-97ec6347cb0e81dad877192c33208794.png";